import type { FC, ReactNode } from "react";
import type { ButtonBasicProps } from "@/components/buttons/shared.ts";
import { styled } from "@linaria/react";
import { theme } from "@/themes/theme.ts";

const ButtonEmptyStyle = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  cursor: pointer;

  transition: all 150ms ${theme.transition};

  &[data-flare="true"] {
    &:hover {
      scale: 110%;
    }

    &:active {
      scale: 90%;
    }
  }
`;

interface ButtonEmptyProps extends ButtonBasicProps {
  children?: ReactNode;
  flare?: boolean;
}

export const ButtonEmpty: FC<ButtonEmptyProps> = ({ onClick, children, tooltip, flare }) => {
  return (
    <ButtonEmptyStyle
      onClick={() => {
        if (onClick) {
          onClick(() => {});
        }
      }}
      data-flare={flare}
      data-tooltip={tooltip}
      data-direction={"top"}
    >
      {children}
    </ButtonEmptyStyle>
  );
};
